import React, { FC, PropsWithChildren } from "react";
import {
  Drawer as MUIDrawer,
  Grid,
  IconButton,
  Link,
  useTheme,
} from "@mui/material";
import DrawerHeader from "../components/DrawerHeader";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DrawerMain from "../components/DrawerMain";
import { DRAWER_WIDTH } from "../styles/sizes";
import DrawerFooter from "../components/DrawerFooter";
import { COLORS } from "../styles/colors";
import useLogout from "../hooks/useLogout";
import useIsPortal from "../hooks/useIsPortal";
import { useNavigate } from "react-router-dom";
import MainMenu from "./MainMenu";
import useAuthentication from "../hooks/useAuthentication";

interface DrawerProps extends PropsWithChildren {
  /** We control the open state from the parent component, with the ability to call the change handler from here */
  open: boolean;
  handleOpenChange: (open: boolean) => void;
}

/**
 * The Tables route element. Includes Header and Drawer Elements, tables are placed inside using
 * react-routers Outlet component.
 */
const Drawer: FC<DrawerProps> = ({ open, handleOpenChange, children }) => {
  const theme = useTheme();
  const { user } = useAuthentication();
  const handleLogout = useLogout();
  const { isPortal } = useIsPortal();
  const navigate = useNavigate();
  return (
    <>
      <MUIDrawer
        sx={{
          width: 200,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: DRAWER_WIDTH,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="right"
        open={open}
      >
        <div style={{ width: "100%", height: "100%" }}>
          <div style={{ height: "55px" }}>
            <DrawerHeader>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <IconButton onClick={() => handleOpenChange(false)}>
                    {theme.direction === "ltr" ? (
                      <ChevronRightIcon />
                    ) : (
                      <ChevronRightIcon />
                    )}
                  </IconButton>
                </Grid>
                <Grid item>
                  <Grid
                    container
                    color={COLORS.tuv_r_black_30}
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={0.5}
                  >
                    {!isPortal && user?.admin && (
                      <>
                        <Grid item>
                          <Link
                            href="/portal"
                            style={{ color: COLORS.tuv_r_black_30 }}
                          >
                            Portal
                          </Link>
                        </Grid>
                        <Grid item style={{ userSelect: "none" }}>
                          |
                        </Grid>
                      </>
                    )}
                    <Grid item>
                      <Link
                        href="#"
                        style={{ color: COLORS.tuv_r_black_30 }}
                        onClick={() => {
                          handleLogout();
                          if (!isPortal) {
                            navigate("/portal");
                          }
                        }}
                      >
                        Logout
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DrawerHeader>
          </div>
          <div style={{ overflowY: "auto", height: "calc(100% - 155px)" }}>
            <MainMenu />
          </div>
          <div
            style={{
              height: "105px",
              width: "100%",
              position: "absolute",
              bottom: 0,
              alignSelf: "center",
            }}
          >
            <DrawerFooter />
          </div>
        </div>
      </MUIDrawer>
      <DrawerMain open={open} sx={{ pb: 0 }}>
        {children}
      </DrawerMain>
    </>
  );
};

export default Drawer;
